import { motion } from "framer-motion"; // For modal entrance animations
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { Box, Typography } from "@mui/material";
import HtmlContent from "../../components/html-content/HtmlContent";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react"; // For Lottie star animations
import RewardIllustration from "../../assets/images/celebration-images/celeb_reward.png";
import StarsAnimation from "../../../src/app/locales/stars.json";

interface RewardClaimedProps {
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}

export const RewardClaimed: React.FC<RewardClaimedProps> = ({
  onClose,
  celebration,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="modal modal--reward"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="modal__reward-visual-wrapper">
        <img
          src={RewardIllustration}
          alt="Reward Milestone"
          className="modal__reward-illustration"
        />
        <div className="modal__stars-wrapper">
          <Lottie
            animationData={StarsAnimation}
            className="modal__stars-lottie"
            loop
          />
        </div>
      </div>
      <Typography variant="body1" mb={3} className="celebration">
        <HtmlContent htmlString={celebration.content || "NA"} />
      </Typography>
      <Box>
        <CustomButton
          onClick={() => onClose(celebration)}
          variant="contained"
          text={t("noShowAppointment.closeButton")}
        />
      </Box>
    </motion.div>
  );
};
